module.exports = __webpack_public_path__ + "img/icon-search.6b6192c4.svg";